// ==============================|| OVERRIDES - APP BAR ||============================== //

export default function AppBar(theme) {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(135deg, #7c5cdb 0%, #764ba2 100%)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          minHeight: '64px',
          height: '64px',
          backdropFilter: 'blur(8px)',
          borderRadius: '0 !important',
          borderTopLeftRadius: '0 !important',
          borderTopRightRadius: '0 !important',
          borderBottomLeftRadius: '0 !important',
          borderBottomRightRadius: '0 !important',
          overflow: 'hidden',
          '& *': {
            borderRadius: '0 !important'
          }
        },
        colorPrimary: {
          background: 'linear-gradient(135deg, #7c5cdb 0%, #764ba2 100%)'
        }
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: '64px !important',
          height: '64px !important',
          '@media (min-width: 600px)': {
            minHeight: '64px !important',
            height: '64px !important'
          },
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2)
        }
      }
    }
  };
}
